<template>
    <div>
    <h2> Desert Tomb:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg', 'Desert Tomb')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/258086887/KS2_Mv7vaoT4MthZoznwlg/original.jpg?16382959795" target="_blank">Map</a><br/>
    <v-row>
        <v-col>
            <img id="Desert Tomb" :src="require('../../../assets/Annotated_Desert_Tomb_Map.png')"  contain height="942px"/>
        </v-col>
        <v-col>
        <h2>Map Details: </h2>
        <ul>
            <li>This area is covered by a curse, any player that damages walls or other parts of the tomb (though not doors) must make a dc 12 will save DC 16 or receive 1d3 points of charisma damage. The doors are made of stone and are 6 inches thick.</li>
            <li>This area is mostly dimly lit by torches, players can see within 40 feet of themselves.</li>
            <li>The ceiling in this area is 15 feet in all rooms unless stated otherwise.</li>
            <li>The first time players are about to collect any gold marked S1 they can make a knowledge religion check DC 13, if they succeed they know this gold is burried with the dead, and although picking it up wont cause any direct harm to them, it may anger whatever inhabits this tomb. After that keep track of how many gold piles marked S1 they collect.</li>
            <li>Map is 30x30</li>
            <ul>
                <li>Player Spawn: Purple</li>
                <li>Treasure: Cyan</li>
                <li>Monsters: Red</li>
                <li>Areas of interest: Green</li>
                <li>Room Number: White</li>
            </ul>
        </ul>

        <h3>1) Wrapping Room</h3>
        <h4>Area Details:</h4>
        <ul>
            <li>This room smells like a strange chemical, and you can faintly hear the sound of chewing coming from a pile of wrapped bodies</li>
        </ul>
        <h4>Monsters:</h4>
        <ul>
            <li><b>1) Adherer CR 3: </b> Adherers appear to be regular mummys, but once players attack them once they notice they are sticky.</li>
        </ul>
        <h4>Treasure:</h4>
        <ul>
            <li><b>1) Enchanted Armor 50</b></li>
            <li><b>2) Weapon 25</b></li>
            <li><b>S1) Small Gold Pile: </b> Requires a DC 16 perception check to notice.</li>
            
        </ul>
        <h4>Areas Of Interest</h4>
        <ul>
            <li><b>1) Blue Key: </b> This key can be used to open AoI 1 in area 6.</li>
            <li><b>2) Blade Trap: </b> Activates on pressure plate. Covers entire 5ft-5ft square Continuous activation 3d6 slashing damage reflex dc 12 for half. DC 18 perception and disable device.</li>
            <li><b>3) Large Stone Boulder: </b> If players open eastern door it rolls towards them. 4d6 bludgeoning damage to all players in its path, reflex 14 for half. It then rolls up the stairs in its path, and 3 rounds later it rolls back, deflecting off the wall and heading north. DC 19 perception to notice door is trapped, and DC 23 disable device to disable. DC 18 perception check to hear it on its way back.</li>
        </ul>
        <br/><br/>
                
        </v-col>
    </v-row>


    <h3>2) Architect's Rest</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This room feels surprisingly cold, two earie statues stare at you as you approach.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Edimmu CR 3: </b> Edimmu will come out from statues and surprise attack players if they take anything from the room.</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Enchanted Typed Weapon 75</b></li>
        <li><b>2) Teamwork Feat 200</b></li>
        <li><b>S1) Small Gold Pile: </b> Players must succeed a DC 23 strength check. Although they can all assist each other and retry on a failure, if they fail by 5 or more they must all make a will save DC 14 or receive 1d2 charisma damage from being cursed.</li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Axe Trap: </b> Magically activates if players enter the square annotated with 1, and it covers the whole 10x5 ft area, once activated swings continuously. Deals 5d6 slashing damage, reflex 14 for half. Once it activates once players can make an escape artist check DC 14 to move past it. DC 19 perception and disable device.</li>
    </ul>
    <br/><br/>        


    <h3>3) Pharaoh's Gate</h3>
        <h4>Area Details:</h4>
        <ul>
            <li>This room is dimly lit, and you see a strange creature with the head of a goat standing at the doorway, but strangely it doesn't attack right away, instead speaking asking the players a riddle.</li>
            <li>When Players enter the room GM can choose to either challenge players with a simple riddle, or players make a DC 25 sense motive check. If players fail, attack monster 1, or try to move past it monster 2 will spawn, both using their sandstorm ability. If players succeed the sense motive check or answer riddle monsters 2 will spawn with 2 negative levels (worth 800 experience), monster 1 will leave, and L1 will appear. They will gain the experience from monster 1 whether they kill it or solve the riddle. You can use a riddle generator or use your own, GM's choice. Each player gets 1 chance to answer the riddle.</li>
        </ul>
        <h4>Monsters:</h4>
        <ul>
            <li><b>1) Pseudosphinx CR 2: </b>Will ask the players a riddle when they enter the room.</li>
            <li><b>2) Sha CR 4: </b> Can use its sandstorm ability to affect all players within 50 ft, DC 14 reflex save or they become blinded for 1d4 rounds. Players can spend a standard action to remove sand from their eyes.</li>
        </ul>
        <h4>Treasure:</h4>
        <ul>
            <li><b>1) Perk 125</b></li>
            <li><b>L1) Large Gold Pile: </b> Appears if players solve Monster 1's riddle.</li>
        </ul>
        <h4>Areas Of Interest</h4>
        <ul>
            <li><b>1) Ambush Point: </b> If players step past this point without solving monster 1's riddle monster 2 both spawn and attack players.</li>
        </ul>
        <br/><br/>


        <h3>4) Pharaoh's Tomb</h3>
        <h4>Area Details:</h4>
        <ul>
            <li>This Room has a large and ornate sarcophagus to its north. As the players enter it cracks open a tad and black mist begins to spread out from the crack.</li>
            <li>The ceiling in this room is 20 feet tall.</li>
            <li>If players enter this room they take 1d6 points of negative energy damage, and be shaken for 1 round, they can make a will save dc 14 to reduce the damage by half and negate the shaken effect. For each pile of gold marked S1 that the part took the damage increases by 1d6, and shaken duration increases by 1 round, and for each two piles the DC increases by 1.</li>
        </ul>
        <h4>Monsters:</h4>
        <ul>
            <li><b>1) Mythic Mummy CR 7: </b> Will spawn 1 round after players enter area</li>
        </ul>
        <h4>Treasure:</h4>
        <ul>
            <li><b>1) E+ Weapon Enchantment 125</b></li>
            <li><b>2) Level Up 225</b></li>
            <li><b>3) Lvl+ typed Spell/Maneuver 60</b></li>
            <li><b>4) R+ Armor Enchantment 100</b></li>
            <li><b>M1) Medium Gold Pile: </b> Requires a dc 18 perception check to notice this gold hidden beneath a golden mask locked to the center of the sarcophagus. A dc 23 craft or knowledge religion to obtain can release the magic keeping it there. If party attempts to break it they receive 8d6 negative energy damage.</li>
        </ul>        
        <br/><br/>


        <h3>5) Sha's Shrine</h3>
        <h4>Area Details:</h4>
        <ul>
            <li>This large room has a 10 foot tall pyramid on top of a raised platform 5 feet tall in the center of it. 3 creatures stand atop of it ready to attack once players enter.</li>
             <li>This room has a 30 foot ceiling</li>
        </ul>
        <h4>Monsters:</h4>
        <ul>
            <li><b>1) Mummified Baboon CR 1/2</b></li>
            <li><b>2) Sha CR 4: </b> Can use its sandstorm ability to affect all players within 50 ft, DC 14 reflex save or they become blinded for 1d4 rounds. Players can spend a standard action to remove sand from their eyes.</li>
        </ul>
        <h4>Treasure:</h4>
        <ul>
            <li><b>1) R+ Stats 25: </b> If players roll a DC 19 knowledge religion or perform they can gain access to this chest.</li>
            <li><b>2) Stats 50</b></li>
            <li><b>3) Ability Score 25: </b> If players roll a DC 14 knowledge religion or perform they can gain access to this chest.</li>
            <li><b>S1) Small Gold Pile: </b> Requires a DC 16 perception check to notice.</li>
            
        </ul>        
        <br/><br/>


        <h3>6) Main Hall</h3>
        <h4>Area Details:</h4>
        <ul>
            <li>This main hall stinks of dust and decay. With a perception check of DC 18 you can hear what sounds like something large slithering around at the back, and the what sounds like laughing coming from the room on your left.</li>
            <li>The ceiling here is 25 feet.</li>
        </ul>
        <h4>Monsters:</h4>
        <ul>
            <li><b>1) Mummified Crocodile CR 2</b></li>
            <li><b>2) Mummified Babbon CR 1/2</b></li>
            <li><b>3) Human Zombie CR 1/2: </b> Stays hidden inside its sarcophagus until combat starts.</li>
        </ul>
        <h4>Treasure:</h4>
        <ul>
            <li><b>1) 2-4 Potions</b></li>
            <li><b>2) Typed Spell/Maneuver 60</b></li>
            <li><b>3) Stats 25</b></li>
            <li><b>S1) Small Gold Pile: </b> Requires a DC 13 perception check to notice.</li>
            
        </ul>
        <h4>Areas Of Interest</h4>
        <ul>
            <li><b>1) Locked Door: </b> Can be opened with a DC 26 disable device check, also has a painted blue key hole. Can be opened using the blue key obtained from AoI 1 in area 1</li>
            <li><b>1) Stone Ramp: </b> This ramp appears as if something has rolled down it multiple times, and there is a small hole at the top of the ramp leading into the wall. If players attempt to climb into it it requires a DC 21 escape artist check, all they find is that the tunnel loops around and comes back out, but also find a small gold pile.</li>
        </ul>
        <br/><br/>


        <h3>7) Arcanist's Study</h3>
        <h4>Area Details:</h4>  
        <ul>
            <li>This room smells of old books and smoke, but there is a slight tinge of the smell of burnt fur as well.</li>
        </ul>
        <h4>Monsters:</h4>
        <ul>
            <li><b>1) Hieracoshynx CR 5: </b></li>
        </ul>
        <h4>Treasure:</h4>
        <ul>
            <li><b>1) Infinite Spells/Maneuvers Chest: </b> This chest can be used by an individual player as many times as they would like.</li>
        </ul>
        <h4>Areas Of Interest</h4>
        <ul>
            <li><b>1) Fire Trap: </b> Shoots out flames covering the whole hallway 10x5 ft. Once it activates it fires continuously. DC 20 perception and disable check. 4d6 fire damage, DC 17 reflex for half.</li>
        </ul>
        <br/><br/>


        <h3>8) Prison</h3>
        <h4>Area Details:</h4>
        <ul>
            <li>You can see something large pacing in the back area barring its teeth pacing back and forth as it watches you enter. A shimmering barrier appears to be surrounding the cages.</li>
        </ul>
        <h4>Monsters:</h4>
        <ul>
            <li><b>1) Cynosphinx CR 6 </b></li>
        </ul>
        <h4>Treasure:</h4>
        <ul>
            <li><b>1) Resurrective 50: </b> Can only be accessed by first unlocking the cage.</li>
            <li><b>1) R+ Perk 125: </b> Can only be accessed by first unlocking the cage.</li>
        </ul>
        <h4>Areas Of Interest</h4>
        <ul>
            <li><b>1) Cage Lever: </b> This opens both cages allowing players to access treasure 1 and M but also causing monster 1 to attack.</li>
            <li><b>2) Locked Cage Door: </b> There is a shimmering barrier around these cages, requires a dispel magic dc 22 or a DC 26 disable device check to open. Once barrier is disabled it also requires a DC 19 disable device to unlock cage.</li>
        </ul>
        <br/><br/>

        
        <h3>9) Desecrated Hall</h3>
        <h4>Area Details:</h4>
        <ul>
            <li>This area stinks of animal instead of undeath, the ornate carvings and paintings of gods that plaster the walls have been scraped over by more primitive drawings of another god, and you hear what sounds like laughter and bowstrings being drawn coming from deeper within the room.</li>
            <li>The Gnolls in this room know of the scorpions on the east side of the room, and so will attempt to attack with ranged weapons until the players enter and are attacked by the scorpion.</li>
        </ul>
        <h4>Monsters:</h4>
        <ul>
            <li><b>1) Gnoll Rageborn CR 3: </b> Prepares to charge the first player who comes around the corner.</li>
            <li><b>2) Gnoll CR 1: </b> Will attempt to use ranged weapons until party engages with the scorpion</li>
            <li><b>3) Flind CR 3: </b> Will attempt to use ranged weapons until party engages with the scorpion</li>
            <li><b>4) Ghost Scorpion CR 1/2: </b> Will sit and wait for something to move past it, then surprise it. Attacks whatever creature is closest each turn.</li>
        </ul>
        <h4>Treasure:</h4>
        <ul>
            <li><b>1) Weapon 25</b></li>
            <li><b>2) Weapon 25</b></li>
            <li><b>3) Armor 25</b></li>
            <li><b>4) 3-5 potions 25: </b> If players can roll a DC 18 survival or knowledge nature check they can turn the scorpions into potions.</li>
            <li><b>S1) Small Gold Pile: </b> Requires a DC 13 perception check to notice.</li>
            <li><b>S2) Small Gold Pile: </b> Requires a DC 19 perception check to notice.</li>
        </ul>
        <h4>Areas Of Interest</h4>
        <ul>
            <li><b>1) Fire Trap: </b> Pressure plate activated on all tiles it fills, fire fills the entire 10x5 foot area, once activated fires continuously. DC 19 perception, and dc 17 disable device. 2d6 fire damage, dc 14 reflex for half.</li>
            <li><b>2) Acid Trap: </b> Pressure plate activated on all tiles it fills, Acid spray fills the entire 10x5 foot area, once activated fires continuously. DC 22 perception, and 16 disable device. 3d6 Acid damage, dc 14 reflex for half.</li>
            <li><b>3) Whirling Blade Trap: </b> Pressure plate activated, multiple whirling blade comes from the wall chest height. Continuous Activation. Covers whole 5x5 area. Once trap has been activated players can sneak under it by going prone and making a dc 8 escape artist check. DC 24 perception, and 16 disable device. 2d6 slashing damage, dc 14 reflex for half. </li>
        </ul>
        <br/><br/>


        <h3>10) Priest's Hall</h3>
        <h4>Area Details:</h4>
        <ul>
            <li>This room seems earily quite and cold. As if something powerful lurks here and all other life has vanished from the room.</li>
            <li>The ceiling in here is 20 feet tall</li>
        </ul>
        <h4>Monsters:</h4>
        <ul>
            <li><b>1) Human Zombie CR 1/2: </b> Waits in its sarcophogus until players cross point AoI 1, then attacks players.</li>
            <li><b>2) Mummy CR 5: </b> Waits in its sarcophogus until players cross point AoI 1, then attacks players.</li>
        </ul>
        <h4>Treasure:</h4>
        <ul>
            <li><b>1) 2-4 Potions 25</b></li>
            <li><b>2) Resurrective 125</b></li>
            <li><b>3) Perk 125</b></li>
            <li><b>S1) Small Gold Pile: </b> Can only be obtained after monster 1 leaves its sarcophagus and requires a DC 17 perception check to notice.</li>
            <li><b>M1) Medium Gold Pile: </b> Can only be obtained after defeating monster 2, requires a DC 19 perception check, and then a DC 19 knowledge religion check. If players fail the knowledge religion check by 5 or more they must make a will save or receive 1d4 charisma damage.</li>
        </ul>
        <h4>Areas Of Interest</h4>
        <ul>
            <li><b>1) Whirling Blade Trap: </b> pressure plate activated, multiple whirling blade comes from the wall chest height. DC 24 perception, and 16 disable device. 2d6 slashing damage, dc 14 reflex for half. Once trap has been activated players can sneak under it by going prone and making a dc 10 escape artist check.</li>
            <li><b>2) Centipede trap: </b> the floor falls out underneath a player, they can make a dc 17 reflex check to not fall in, otherwise they are bitten by centipedes, making 3 fortitude saves dc 13 or be poisoned 1d3 dex damage per round for 6 rounds. Each failed save increases DC by 2 and duration by 2 rounds.</li>
            <li><b>3) Ambush Point: </b> monsters 1 and monster 2 attack after any player crosses past area</li>
        </ul>
        <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>